import React,{useEffect,useState,Fragment} from "react";
import '../../../style/step-wizard.css'
import { connect } from "react-redux";
import { Form, FormGroup, Label, Input, Row, Col,Table} from "reactstrap";
import {    
    GetPerformanceLearnningPlan,
    GetRatingList,
    SubmitData
  } from "../../../redux/actions/appraisal/appraisal.action";
import Moment from "moment";
import AddDelPerformancePlan from "./AddDelPerformancePlan";
import { useHistory } from "react-router-dom";
import api from "../../../apis/api";
const inputHeight = { height: "35px" };
const PreviousPerformanceGoals = (props) => {
    const {GetRatingList,SubmitData}=props;
    const {ratings} = props.ratings;
    // const {performancelearningplan} = props.performancelearningplan;
    const [reviewFrom, setReviewFrom] = useState('');
    const [reviewTo, setReviewTo] = useState('');
    const [learningArea, setLearningArea] = useState('');
    const [learningPlan, setLearningPlan] = useState('');
    const [learningMode, setlearningMode] = useState('');
    const [appraiserComment, setAppraiserComment] = useState('');
    const [appraiseeComment, setAppraiseeComment] = useState('');
    const [overallRating, setOverallRating] = useState('');
    const [performanceLearningPlanId, setPerformanceLearningPlanId] = useState(0);

    const [performancePlanArr,setPerformancePlanArr] = useState([]);
    const [performancePlanList,setPerformancePlanList] = useState([]);
    const [enableEdit,setEnableEdit] = useState(false);
    const [showData,setshowData] = useState(false);
    const [PreviousAppraisalStatus,setPreviousAppraisalStatus] = useState(false);
    const [appraisalYear,setappraisalYear] = useState('');
    const [viewtype,setViewType] = useState(0);
    const [checked, setChecked] = React.useState(false);
const [performancelearningplan, setPerformanceLearningPlan] = useState([]);
   
    const handleChange = () => {
      setChecked(!checked);
    };
    var loginUser = JSON.parse(localStorage.getItem("user"));
    const history = useHistory();
    useEffect(()=>{ 
        const currentYear = new Date().getFullYear(); // 2020   
        let previousYear = currentYear-1;
        let year = JSON.parse(window.sessionStorage.getItem("year"));
        let type = JSON.parse(window.sessionStorage.getItem("type"));
        setViewType(type);
        if(year == null)
        {          
          year =  previousYear;
        }

        if(year == previousYear)
        {
          setPreviousAppraisalStatus(true);
        }
        let payload={
        empId:loginUser.EmployeeId,
        year : year,
        type:type
      }
      setappraisalYear(year);
       const fetchData = async () => {
        
              const response = await api.appraisal().GetPreviousPerformanceLearningPlanByAppraiseeId(payload);
              
           
                setPerformanceLearningPlan(response.data);
              
            }
          fetchData();
      // GetPerformanceLearnningPlan(payload);
      GetRatingList();
      },[GetRatingList,setPerformanceLearningPlan]);
      useEffect(()=>{

        if(performancelearningplan!=undefined && performancelearningplan!=null && performancelearningplan!=''){
          setshowData(true)
          setReviewFrom(Moment(performancelearningplan.reviewPeriodFrom).format("YYYY-MM-DD"));
          setReviewTo(Moment(performancelearningplan.reviewPeriodTo).format("YYYY-MM-DD"));
          setLearningArea(performancelearningplan.personalLearningArea);
          setLearningPlan(performancelearningplan.proposedLearningPlan);
          setlearningMode(performancelearningplan.modeOfLearning);
          setAppraiserComment(performancelearningplan.appraiserComment);
          setAppraiseeComment(performancelearningplan.appraiseeComment);
          setOverallRating(performancelearningplan.performanceRating);
          setPerformancePlanList(performancelearningplan.performancePlanList);
          setPerformanceLearningPlanId(performancelearningplan.performance_learning_plan_id)
        }
        
      },[performancelearningplan])

      const AcceptAppraisal=()=>{
        if(checked){
          var data = {
            empId:parseInt(loginUser.EmployeeId),
            reviewType: 3
          }
          SubmitData(data); 
          history.push({
            pathname: "/empAppraisal",      
          });
        }
        else{
          alert("Kindly check the Accept checkbox and Submit.")
        }
        
      }

      return(
       
        <Fragment>
             {showData ? (
             <div>
               {PreviousAppraisalStatus?
               (
                 <div>
                  <h6 className="header-center">PERFORMANCE PLAN/GOALS OF CURRENT REVIEW PERIOD</h6>
                  <div  className="header-sub"> <span>(Performance Plan/goals discussed as per previous year Appraisal.)</span></div>                  
                </div>
                ) :
                (
                  <div>
                  <h6 className="header-center">PERFORMANCE PLAN/GOALS FOR THE NEXT REVIEW PERIOD</h6>
                  <div  className="header-sub"> <span>(Review and Accept Appraisal - {appraisalYear}.)</span></div>                  
                </div>
                )
               }
            
             <div>
             <h6 className="header-bg">PERFORMANCE PLAN</h6>
             <Form>
             <FormGroup row>
                 <Label sm={3}>Review Period : From</Label>
                     <Col sm={3}>            
                         <Input
                           type="date"
                           style={inputHeight}
                           placeholder={"MMM yyyy"}
                           onChange={(e) => setReviewFrom(e.target.value)}
                           value = {reviewFrom}
                           disabled
                         />
                       </Col>
                       <Label sm={3}>Review Period : To</Label>
                     <Col sm={3}>            
                         <Input
                           type="date"
                           style={inputHeight}
                           placeholder={"MMM yyyy"}
                           onChange={(e) => setReviewTo(e.target.value)}
                           value = {reviewTo}
                           disabled
                         />
                     </Col>
               </FormGroup>
               
               <AddDelPerformancePlan setData={setPerformancePlanArr} performancePlanList={performancePlanList} enableEdit={enableEdit}/>
               <h6 className="header-bg">PERSONAL LEARNING PLAN</h6>
               <div><span>You should fill this during the review after discussion with the reviewer. Identify at least one competency you want to develop.</span></div>
               <Table className="performance-table">
                   <thead>
                     <tr>
                     <th>Personal learning area</th>
                     <th>Proposed learning plan</th>
                     <th>Mode of learning</th>
                     </tr>                       
                   </thead>
                   <tbody>
                       <tr>
                           <td> 
                             <Input
                             type="textarea"
                             placeholder="Explain Learning area."
                             onChange={(e) => setLearningArea(e.target.value)}
                             value = {learningArea}
                             disabled
                             />
                             </td>
                           <td> 
                             <Input
                             type="textarea"
                             placeholder="Explain Learning Plan."
                             onChange={(e) => setLearningPlan(e.target.value)}
                             value = {learningPlan}
                             disabled
                             />
                             </td>
                           <td> 
                             <Input
                             type="textarea"
                             placeholder="Explain mode of Learning."
                             onChange={(e) => setlearningMode(e.target.value)}
                             value = {learningMode}
                             disabled
                             />
                             </td>
                       </tr>
                   </tbody>          
               </Table>     
               <h6 className="header-bg">Review Comments By Appraiser</h6>
               <FormGroup row>
                <Table className="performance-table">
                   
                   <tbody>
                       <tr>
                           <td> 
                             <Input
                             type="textarea"
                             placeholder="Explain Learning area."
                             onChange={(e) => setAppraiserComment(e.target.value)}
                             value = {appraiserComment}
                             disabled
                             />
                             </td>
                           
                       </tr>
                   </tbody>          
               </Table> 
               </FormGroup>         
             <FormGroup row className="overall-rating">
                 <Col md={3} className="overall-rating-col">OVERALL RATING OF THE APPRAISEE</Col>
                 <Col md={5}> 
                 <Input 
                 type="select" 
                 name="finalReview" 
                 className="form-control review-drop" 
                 disabled  
                 onChange={(e) => setOverallRating(e.target.value)}>
                    <option value="0">Select</option>                                           
                      {ratings.map((rating, i) => (
                      <option
                      key={i}
                      value={rating.ratingId} 
                      selected={
                        overallRating? (overallRating == rating.ratingId  ? true : false):false
                      }  
                      >
                      {rating.rating}
                    </option>
                    ))}         
                    </Input>
                  </Col>
             </FormGroup>
             {viewtype==2 ? 
             (
              <FormGroup row>
              <Col md={12} style={{textAlign:"center"}}>
                      <label>
                       <input type="checkbox" style={{width:"22px",height:"22px"}} onChange={handleChange}/>
                       &nbsp; <b>I have reviewed and accepted the above mentioned appraisal rating and performance plan for the next review period.</b>
                     </label>              
              </Col>
              <Col md={12} style={{textAlign:"center"}}>
              <input 
                 type="button"
                 value="Submit" 
                 className='btn-admin-settings btn'
                 onClick={AcceptAppraisal} 
                 />        
              </Col>
            </FormGroup> 
             ):null}
                  
             </Form>
             </div>  
             </div>
            ):(<div>
                <h3 style={{color:"gray" ,textAlign: "center"}}>Sorry No Results Found.</h3>
                <span><i className="fa fa-frown-o"></i></span>
            </div>)}
           
        </Fragment>
        );
};
const mapStateToProps = (state) => ({
    ratings : state.appraisalReducer,
    performancelearningplan : state.appraisalReducer
});
export default connect(mapStateToProps, {
    GetPerformanceLearnningPlan,
    GetRatingList,
    SubmitData
})(PreviousPerformanceGoals);